$(function() {
  var
    $window = $(window),
    $modal = $('.js-modal'),
    st = $window.scrollTop() + $window.height();

  function scrollTo(offset, duration) {
    offset = offset || 0;
    duration = duration || 1000;
    $('html,body').stop().animate({
      scrollTop: offset
    }, duration, 'easeOutCubic');
  }

  function detect(st) {
    st = st || 0;

    $('.js-effect').each(function(){
      if($(this).offset().top <= st) {
        if($(this).hasClass('cocked')) $(this).removeClass('cocked');
      }
    });
  }

  $modal.hide();

  detect(st);

  $('.js-anchor')
    .on('click', function() {
      var
        $tName = $($(this).attr('href'));

      if ($tName.length) {
        var scroll = $tName.offset().top;

        scrollTo(scroll, 700);
      }
      return false;
    });

  $('.js-folder')
    .on('click', '.js-btn', function() {
      var
        $p = $(this).parents('.js-folder').eq(0),
        $t = $('.js-body', $p).eq(0);

      $p.toggleClass('open');
      if ($p.hasClass('open')) $t.slideDown(300);
      else $t.slideUp(300);

      return false;
    });

  $('.js-popup-init')
    .on('click', function(){
      document.getElementById('voucher1').click();
      document.getElementById('voucher2').click();
      $('.js-modal').fadeIn(300);

      return false;
    });

  $('.js-popup')
    .on('click', '.js-close', function(){
      $modal.fadeOut(300);

      return false;
    })
    .on('click', function(e){
      e.stopPropagation();
    });

  $modal
    .on('click', function(){
      $modal.fadeOut(300);
    });

  $(window)
    .on('scroll', function(){
      st = $window.scrollTop() + $window.height();
      detect(st);
    });
});